import Bt, { type ButtonProps } from "@mui/material/Button";

export const Button = ({ variant = "contained", ...props }: ButtonProps & Record<string, unknown>) => {
    return <Bt variant={variant} {...props} />;
};
